import glamorous from 'glamorous'
import { mediumAndSmaller } from 'lib/styles/media-queries'

export const SelectButton = glamorous.button('vx_btn', {
  minWidth: '9rem',
  marginTop: '30px',
  lineHeight: 1,
  width: '114px',
  borderRadius: '50px',
  fontWeight: '700',
  [mediumAndSmaller]: {
    display: 'none',
  },
})

export const CenterContentHeader = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  [mediumAndSmaller]: {
    flexDirection: 'row',
    paddingLeft: '-60px',
  },
})

export const OptionHeader = glamorous.div({
  textAlign: 'center',
  marginTop: '10px',
  marginBottom: '10px',
  fontWeight: 'bold',
  fontSize: '20px',
  [mediumAndSmaller]: {
    marginBottom: '0px',
    marginTop: '0px',
    fontSize: '16px',
    width: '220px',
    textAlign: 'initial',
    paddingLeft: '20px',
  },
})

export const PaymentOptionList = glamorous.ul({
  maxWidth: '220px',
  marginLeft: '30px',
  marginTop: '40px',
  minHeight: '175px',

  [mediumAndSmaller]: {
    minHeight: '150px',
    listStyleType: 'none',
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 'auto',
    paddingLeft: '15px',
  },
})

export const ButtonContainer = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  maxWidth: '220px',
  marginLeft: '30px',
  marginTop: '20px',
  [mediumAndSmaller]: {
    listStyleType: 'none',
    marginLeft: '0',
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '220px',
    justifyContent: 'flex-start',
  },
})

export const PaymentOptionListItem = glamorous.li({
  marginBottom: '20px',
  paddingLeft: '10px',
  lineHeight: '1.6',
  [mediumAndSmaller]: {
    lineHeight: '1.2',
  },
})

export const Divider = glamorous.div({
  backgroundColor: '#999',
  width: '1px',
  marginRight: '35px',
  marginLeft: '35px',
  marginTop: '102px',
  marginBottom: '120px',
  [mediumAndSmaller]: {
    marginTop: '0px',
    marginBottom: '35px',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '240px',
    height: '1px',
    visibility: 'hidden',
  },
})

export const SendingMoneyHeader = glamorous.div({
  textAlign: 'center',
  fontSize: '30px',
  lineHeight: '1.4',
  fontWeight: '300',
  textTransform: 'none',
  fontFamily: 'sans-serif',
  [mediumAndSmaller]: {
    fontSize: '20px',
  },
})

export const PaymentOptionContainer = glamorous.div({
  [mediumAndSmaller]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderColor: 'rgb(225, 231, 235)',
    borderRadius: '10px',
    padding: '4%',
    boxSizing: 'border-box',
    borderWidth: '1px',
    borderStyle: 'solid',
    cursor: 'pointer',
    maxWidth: '390px',
    transition: 'border-color 0.2s ease 0s',
    ':hover': {
      borderColor: 'rgb(0, 156, 222)',
    },
  },
})

export const PaymentContainer = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  [mediumAndSmaller]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
})

export const PaymentTypes = glamorous.div({
  margin: '5% auto',
})
